import { render, staticRenderFns } from "./MemberRegistration.vue?vue&type=template&id=583abee0&scoped=true"
import script from "./MemberRegistration.vue?vue&type=script&lang=js"
export * from "./MemberRegistration.vue?vue&type=script&lang=js"
import style0 from "./MemberRegistration.vue?vue&type=style&index=0&id=583abee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583abee0",
  null
  
)

export default component.exports